import VerifyAddress from './VerifyAddress';

export default VerifyAddress;
